

























































import { computed, defineComponent, ref, watch, toRefs, onUnmounted, getCurrentInstance } from '@vue/composition-api';
import { ChevronLeftIcon, CheckCircleFilledIcon, LoadingIcon, CloseCircleFilledIcon } from 'tdesign-icons-vue';
import _ from 'lodash';

import TaskDetail from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/TaskDetail.vue';

import i18n, { i18n_t } from '@/locales/i18n';
import { SMH } from '@/renderer/scripts/smh';
import ipc from '@/renderer/scripts/utils/ipc';
import { formatError } from '@/renderer/scripts/utils/errorCode';

import syncWeworkHanlder from '@/renderer/views/desktop/ManageConsole/AccountAssociation/composition/syncWeworkHandler';

type StatusMap = Record<
  number,
  {
    code: number;
    message: string;
    icon: string;
    class: string;
  }
>;

export default defineComponent({
  components: {
    CheckCircleFilledIcon,
    LoadingIcon,
    CloseCircleFilledIcon,
    ChevronLeftIcon,
    TaskDetail,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    syncType: {
      required: true,
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const showDetail = ref(false);
    const taskResult = ref<
      | (SMH.SyncWeworkOrgResultData & {
          creationTime: string;
        })
      | null
    >(null);
    const { columns, loading: loadingList, tableData, methods: syncMethods } = syncWeworkHanlder();
    const renderList = computed(() =>
      tableData.list.map(item => {
        let statusCode = item.status as number;
        const statusMap: StatusMap = {
          200: {
            code: 200,
            message: i18n_t('同步成功'),
            class: 'success',
            icon: 'check-circle-filled',
          },
          202: {
            code: 202,
            class: 'running',
            message: i18n_t('同步中'),
            icon: 'loading',
          },
          207: {
            code: 207,
            class: 'error',
            message: i18n_t('同步失败'),
            icon: 'close-circle-filled',
          },
          400: {
            code: 400,
            class: 'error',
            message: i18n_t('同步失败'),
            icon: 'close-circle-filled',
          },
          500: {
            code: 500,
            class: 'error',
            message: i18n_t('同步失败，服务器错误'),
            icon: 'close-circle-filled',
          },
        };
        // 错误码4开头代表同步失败，5开头代表服务器，统一处理避免遗漏
        if (Math.round(statusCode / 100) === 5) statusCode = 500;
        if (Math.round(statusCode / 100) === 4) statusCode = 400;
        const status = statusMap[statusCode];
        if ((item.result as SMH.AsyncTaskResult)?.code) {
          const { code } = item.result as SMH.AsyncTaskResult;
          if (code)
            status.message = i18n_t('同步失败，{slot1}', {
              slot1: formatError(code, true),
            });
        }
        return {
          ...item,
          status,
        };
      }),
    );

    const drawerWidth = ref('40%');

    const syncParams: { [key: string]: string } = {
      yufu: 'SyncYufuOrg',
      wework: 'SyncWeworkOrg',
      openLdap: 'SyncAccountOrg',
      windowsAd: 'SyncAccountOrg',
      supwisdom: 'SyncAccountOrg',
    };

    const methods = {
      viewDetail(
        result: SMH.SyncOrgResultData & {
          creationTime: string;
        },
      ) {
        taskResult.value = result;
        showDetail.value = true;
      },
      onRendererDrawerWidth: ({ width }: { width: number }) => {
        const tmp = (7000 / width).toFixed(1);
        drawerWidth.value = `${Math.max(+tmp, 3) * 10}%`;
      },
      handleBack() {
        showDetail.value = false;
      },
      handleClose() {
        showDetail.value = false;
        innerShow.value = false;
      },
      refresh() {
        if (innerShow.value) {
          syncMethods.pullList(syncParams[props.syncType] as CoFile.SyncType);
        }
      },
    };
    methods.onRendererDrawerWidth({
      width: document.body.clientWidth,
    });
    ipc.on(ipc.RENDERER_EVENTS_MAP.WIN_RESIZE, methods.onRendererDrawerWidth);
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.WIN_RESIZE, methods.onRendererDrawerWidth);
    });
    watch(innerShow, val => {
      if (val) {
        syncMethods.pullList(syncParams[props.syncType] as CoFile.SyncType);
      }
    });
    return {
      drawerWidth,
      innerShow,
      columns,
      loadingList,
      ...toRefs(tableData),
      renderList,
      showDetail,
      taskResult,
      ...methods,
    };
  },
});
